export const initSmoothAnchorScroll = () => {
  // Only handle anchor link clicks, not mouse wheel scrolling
  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    const link = target.closest('a');
    
    if (link && link.getAttribute('href')?.startsWith('#')) {
      e.preventDefault();
      const targetId = link.getAttribute('href')?.slice(1);
      if (targetId) {
        const element = document.getElementById(targetId);
        if (element) {
          smoothScrollTo(element);
        }
      }
    }
  });

  // Add smooth scrolling CSS for the page
  document.documentElement.style.scrollBehavior = 'smooth';
};

const smoothScrollTo = (element: HTMLElement, offset = 80) => {
  const rect = element.getBoundingClientRect();
  const absoluteTop = rect.top + window.scrollY - offset;
  
  window.scrollTo({
    top: absoluteTop,
    behavior: 'smooth'
  });
};

export const destroySmoothAnchorScroll = () => {
  document.documentElement.style.scrollBehavior = 'auto';
};